module.exports = {"terms-conditions":"Términos y condiciones","contact":"Contacto","legal-notice":"Aviso legal","cookies-policy":"Política de cookies","privacy-policy":"Política de privacidad","faqs":"Preguntas frecuentes","sgsi-policy":"Política SGSI"}


//////////////////
// WEBPACK FOOTER
// ./src/lang/es/public/footer-360.json
// module id = 296
// module chunks = 117